<template>
  <div>
    <vx-card class="w-full mb-6">
      <vs-table ref="commentTable" stripe class="vs-con-loading__container" single @selected="handleSelectedComment" pagination :max-items="itemsPerPage" search :data="comments" v-scroll-to="'#commentInfoCard'">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
          <div class="flex flex-wrap-reverse items-center">
            <!-- ADD NEW -->
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showDetailsCard" >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>

          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ comments.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : comments.length }} of {{ comments.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=50">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="description">Description</vs-th>
          <vs-th sort-key="modifiedOn">Modified On</vs-th>
          <vs-th sort-key="modifiedBy">Modified By</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="comment" :key="indextr" v-for="(comment, indextr) in data">

            <vs-td :data="data[indextr].description">
              {{ comment.description }}
            </vs-td>

            <vs-td :data="data[indextr].modifiedOn">
              {{ comment.modifiedOn.replace("T", " ").split('.')[0] }}
            </vs-td>

            <vs-td :data="data[indextr].modifiedBy">
              {{ comment.modifiedBy }}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card id="commentInfoCard" ref="commentInfo" class="mb-6" :title="commentCardTitle" v-show="!isInfoHidden">
      <div class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Description</label>
          <vs-textarea autocomplete="off" onClick="this.select();" counter="256" :counter-danger.sync="counterDanger" class="w-full" v-model="formData.description" />
        </div>
      </div>

      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" :disabled="isDisabled" @click.prevent="saveEditComment" ref="saveEditButton">Save</vs-button>
          <vs-button color="danger" v-show="formData.id" class="mr-5 mb-2 vs-con-loading__container" @click.prevent="deleteComment" ref="deleteButton">Delete</vs-button>
          <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#commentInfoCard'" @click="cancelAdd">Cancel</vs-button>
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>
  export default {
    components: {
      
    },
    data() {
      return {
        loadingColor:'#fff',
        selected: [],
        itemsPerPage: 6,
        isMounted: false,
        isInfoHidden: true,
        comments: [],
        formData: {
          id: 0,
          description: ""
        },
        mode: "",
        commentCardTitle: "",
        counterDanger: false
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.commentTable.currentx;
        }
        return 0;
      },
      isDisabled: function() {
        return !(this.formData.description);
      }
    },
    methods: {
      initValues() {
        this.formData.id = 0;
        this.formData.description = "";
        this.mode = "";
        this.isInfoHidden = true;
        this.errors.clear();
      },
      cancelAdd() {
        this.initValues();
        this.isInfoHidden = true;
      },
      saveData() {
        this.initValues();
        this.loadData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
      },
      loadData() {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function (response) {
          self.comments = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.commentTable.$el);
        };

        self.$ajaxGet(self, "PredefinedComment/ListComments", onSuccess, onFinally);
      },
      showDetailsCard(){
        var self = this;
        self.errors.clear();
        self.initValues();
        self.isInfoHidden = false;
        self.mode = "Add New";
        self.commentCardTitle = "Add Comment";
      },
      handleSelectedComment(comment) {
        var self = this;
        self.isInfoHidden = false;
        self.mode = "Update";
        self.commentCardTitle = "Edit Comment";
        self.formData.id = comment.id;
        self.formData.description = comment.description;
      },
      saveEditComment() {
        var self = this;
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnSaveButton();

            var onSuccess = response => {
              self.formData.id = response.data;
              self.saveData();
              if(self.mode != "Add New"){
                self.isInfoHidden = true;
                self.initValues();
              }else
                self.defaultButtonsHidden = true;

              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Comment Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.saveEditButton.$el);
            };
            self.$ajaxPost(self, "PredefinedComment/AddEditComment", self.formData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      deleteComment() {
        var self = this;
        self.showLoadingOnDeleteButton();

        var onSuccess = response => {
          self.saveData();
          self.initValues();
          self.errors.clear();
          self.isInfoHidden = true;
          self.scrollToNavbar();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Comment Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteButton.$el);
        };

        self.$ajaxGet(self, "PredefinedComment/DeleteComment/" + self.formData.id, onSuccess, onFinally);
      },
      showLoadingOnSaveButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.saveEditButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.commentTable.$el,
          scale: 1
        });
      },
      showLoadingOnCommentInfoCard(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.commentInfo.$el,
          scale: 1
        });
      },
      showLoadingOnDeleteButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.deleteButton.$el,
          scale: 0.45
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
    },
    mounted() {
      var self = this;
      self.loadData();
      self.isMounted = true;
    },
  }

</script>